import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { transferAlarmProfilesToClientUseCase } from "@src/cloud-connect/alarms/use-cases/transfer-alarm-profiles-to-client";
import {
  getAlarmProfiles,
  getAlarmProfilesReferenceCopy,
} from "@src/cloud-connect/dependency-injection-container/get-alarm-profiles";
import { RootState } from "@src/reducers/store";
import {
  emptyAlarmNodeData,
  updateAlarmNodeSelectionData,
  updateAlarmNodeSelectionState,
  updateNodeManagerActiveView,
  updateShowUnsavedConditionMonitoringForNodeManagerNavigationModal,
} from "@src/reducers/your-reducer";

export const useUnsavedConditionMonitoringForNodeManagerNavigationModalHook =
  () => {
    const [saveStructureLoading, setSaveStructureLoading] = useState(false);

    const dispatch = useDispatch();

    const activeViewSentToModalForNavigation = useSelector(
      (state: RootState) =>
        state.yourSlice.unsavedConditionMonitoringForNodeManagerNavigationModal
          .activeViewForNavigation,
    );

    const flushAlarmRowSidePanelInfo = () => {
      dispatch(updateAlarmNodeSelectionState("none"));
      dispatch(updateAlarmNodeSelectionData(emptyAlarmNodeData));
    };

    const restoreReferenceAlarmProfilesOnCurrentAlarmProfiles = () => {
      const alarmProfilesInstance = getAlarmProfiles();
      const alarmProfilesReferenceCopy = getAlarmProfilesReferenceCopy();

      const clonedAlarmProfilesReference = alarmProfilesReferenceCopy.clone();

      alarmProfilesInstance.setAlarmProfiles(
        clonedAlarmProfilesReference.getAlarmProfiles(),
      );
    };

    const proceedWithoutSaving = () => {
      closeModal();
      restoreReferenceAlarmProfilesOnCurrentAlarmProfiles();
      flushAlarmRowSidePanelInfo();
      dispatch(updateNodeManagerActiveView(activeViewSentToModalForNavigation));
    };

    const saveStructureAndProceed = async () => {
      await transferAlarmProfilesToClientUseCase(setSaveStructureLoading);
      closeModal();
      flushAlarmRowSidePanelInfo();
      dispatch(updateNodeManagerActiveView(activeViewSentToModalForNavigation));
    };

    const closeModal = () => {
      dispatch(
        updateShowUnsavedConditionMonitoringForNodeManagerNavigationModal(
          false,
        ),
      );
    };

    return {
      closeModal,
      saveStructureAndProceed,
      proceedWithoutSaving,
      saveStructureLoading,
    };
  };
